// extracted by mini-css-extract-plugin
export default {"container":"yha3Y","loaderIcon":"kbTKR","rotate":"AObdX","loader":"YCzSX","childIconWrapper":"XnNx3","childIcon":"iGST7","text":"y7Rpr","skeleton-progress":"OhqLJ"};